import React from 'react';
import Icon from './Icon';
//TODO Use this component instead of the hardcoded markup below
// import Follow from 'mlb-react-patterns/components/Follow';

export default function Social() {
  // const accounts = [
  //     {
  //         service: 'facebook',
  //         hideAccount: false,
  //         account: '@mlb',
  //         url: 'https://www.facebook.com/mlb'
  //     },
  //     {
  //         service: 'twitter',
  //         hideAccount: false,
  //         account: '@mlb',
  //         url: 'https://www.twitter.com/mlb'
  //     },
  //     {
  //         service: 'instagram',
  //         hideAccount: false,
  //         account: '@mlb',
  //         url: 'https://www.instagram.com/mlb'
  //     }
  // ];
  return /*#__PURE__*/React.createElement("dl", {
    className: "p-follow site-footer__social"
  }, /*#__PURE__*/React.createElement("dt", null, "Connect with MLB"), /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement("ul", {
    className: "p-follow p-follow--sm",
    "data-cid": "footer"
  }, /*#__PURE__*/React.createElement("li", {
    className: "p-follow__item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "p-follow__link",
    title: "Follow on facebook",
    href: "https://www.facebook.com/mlb"
  }, /*#__PURE__*/React.createElement("span", {
    className: "p-follow__logo p-follow__logo--facebook"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "facebook"
  })))), /*#__PURE__*/React.createElement("li", {
    className: "p-follow__item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "p-follow__link",
    title: "Follow on twitter",
    href: "https://twitter.com/mlb"
  }, /*#__PURE__*/React.createElement("span", {
    className: "p-follow__logo p-follow__logo--twitter"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "x"
  })))), /*#__PURE__*/React.createElement("li", {
    className: "p-follow__item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "p-follow__link",
    title: "Follow on instagram",
    href: "https://www.instagram.com/mlb"
  }, /*#__PURE__*/React.createElement("span", {
    className: "p-follow__logo p-follow__logo--instagram"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "instagram"
  })))))));
}